import React from 'react';
import BasePageContainer from 'src/components/CommonV2Components/BasePageContainer/BasePageContainer';
import UnitsReturnedProductGrid from './UnitsReturnedProductGrid';
import Flex from 'src/components/BeaconV2Components/Flex/Flex';
import { BEACON_CHART_SPACING } from 'src/components/Layout/Beacon/BeaconProLayoutConsts';
import BeaconComparableSplineChart from 'src/components/BeaconV2Components/BeaconMetricSplineChart/BeaconComparableSplineChart';
import BeaconDropdownMetricColumnChart from 'src/components/BeaconV2Components/BeaconMetricColumnChart/BeaconDropdownMetricColumnChart';
import { useMainEntityType } from 'src/utils/Hooks/reduxSelectors';
import { ChartContextProvider } from 'src/utils/chartContext/ChartContextGroupContext';
import { CHART_CONTEXT_GROUPS, CHART_NAMES } from 'src/utils/chartContext/chartContextRegistry';

const ReturnsPage = () => {
  const entityType = useMainEntityType();

  return (
    <BasePageContainer>
      <Flex flexDirection="column" gap={BEACON_CHART_SPACING}>
        <ChartContextProvider
          group={CHART_CONTEXT_GROUPS.BEACON_RETURN_RATE.name}
          chartName={CHART_NAMES.BEACON_RETURN_RATE_SPLINE}
        >
          <BeaconComparableSplineChart indexName="sales" fieldName="returnRate" />
        </ChartContextProvider>
        <ChartContextProvider
          group={CHART_CONTEXT_GROUPS.BEACON_UNITS_RETURNED.name}
          chartName={CHART_NAMES.BEACON_UNITS_RETURNED_SPLINE}
        >
          <BeaconComparableSplineChart indexName="sales" fieldName="unitsReturned" />
        </ChartContextProvider>
        <ChartContextProvider
          group={CHART_CONTEXT_GROUPS.BEACON_RETURN_RETAIL_VALUE.name}
          chartName={CHART_NAMES.BEACON_RETURN_RETAIL_VALUE_SPLINE}
        >
          <BeaconComparableSplineChart indexName="sales" fieldName="returnRetailValue" />
        </ChartContextProvider>
        <ChartContextProvider
          group={CHART_CONTEXT_GROUPS.BEACON_RETURN_RATE_BY_ENTITY.name}
          chartName={CHART_NAMES.BEACON_RETURN_RATE_BY_ENTITY_COLUMN}
        >
          <BeaconDropdownMetricColumnChart
            indexName="sales"
            fieldName="returnRate"
            dropdownOptions={[
              {
                id: 'subCategoryId',
                label: 'Subcategory'
              },
              {
                id: 'categoryId',
                label: 'Category'
              },
              {
                id: 'brandId',
                label: 'Brand'
              }
            ].filter((option) => !option.id.toLowerCase().startsWith(entityType))}
            titlePrefix="Return Rate % by"
          />
        </ChartContextProvider>
        <UnitsReturnedProductGrid />
      </Flex>
    </BasePageContainer>
  );
};

export default ReturnsPage;
